import { push } from "connected-react-router";
import React from "react";
import { connect } from "react-redux";
import classes from "./WelcomeCard.module.scss";
interface IWelcomeCardProps {
  title: JSX.Element | JSX.Element[];
  desc: JSX.Element | JSX.Element[];
  icon: JSX.Element | boolean | number;
  url?: string;
  showBadge?: boolean;
  badgeValue?: string;
  changeLocation: (url: string) => {};
  onCardClick?: () => void;
  fixedHeight?: boolean;
}

const WelcomeCard = (props: IWelcomeCardProps) => {
  const {
    desc,
    icon,
    title,
    url,
    changeLocation,
    showBadge = false,
    badgeValue,
    onCardClick,
    fixedHeight = false,
  } = props;
  return (
    <React.Fragment>
      <div
        onClick={() => (url ? changeLocation(url) : onCardClick!())}
        className={` ${classes["wrapper-welcome-card"]}`}
        style={
          fixedHeight
            ? {
                height: "10rem",
              }
            : {}
        }
      >
        {showBadge && (
          <div className={classes["badge-wrapper"]}>
            <div className={classes.badge}>{badgeValue && badgeValue}</div>
          </div>
        )}
        <div className={classes["icon"]}>{icon}</div>
        <div className={classes["title"]}>{title}</div>
        <div className={classes["desc"]}>{desc}</div>
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps: any = {
  changeLocation: (url: any) => push(url),
};

const withConnect: any = connect(null, mapDispatchToProps);

export default withConnect(WelcomeCard);
